import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/comments-emotions-xs.png")